import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert
} from 'reactstrap';
import { FiRefreshCw } from 'react-icons/fi';
import assets from '../../assets/assets';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    city: '',
    email: '',
    phone: '',
    whatsapp: '',
    travelDate: '',
    noOfDays: '',
    noOfPersons: '',
    captcha: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  // Generate simple captcha
  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    const operation = Math.random() > 0.5 ? '+' : '*';
    return `${num1} ${operation} ${num2} = ?`;
  };

  const [captchaQuestion, setCaptchaQuestion] = useState(generateCaptcha());

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Validate captcha
  const validateCaptcha = () => {
    const parts = captchaQuestion.split(' ');
    const num1 = parseInt(parts[0]);
    const operation = parts[1];
    const num2 = parseInt(parts[2]);

    let correctAnswer;
    if (operation === '+') {
      correctAnswer = num1 + num2;
    } else {
      correctAnswer = num1 * num2;
    }

    return parseInt(formData.captcha) === correctAnswer;
  };

  // Updated validation - only required fields
  const validateForm = () => {
    const newErrors = {};

    // Only these fields are required
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
    if (!formData.whatsapp.trim()) newErrors.whatsapp = 'WhatsApp number is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';

    // Email format validation
    if (formData.email.trim() && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    // Captcha validation - always required
    if (!formData.captcha.trim()) {
      newErrors.captcha = 'Captcha is required';
    } else if (!validateCaptcha()) {
      newErrors.captcha = 'Incorrect captcha answer';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return; // No error message, just prevent submission
    }

    setIsSubmitting(true);

    // Format phone number (remove spaces, dashes, etc.)
    const cleanPhone = formData.phone.replace(/[\s\-\(\)]/g, '');
    const cleanWhatsApp = formData.whatsapp.replace(/[\s\-\(\)]/g, '');

    // Create WhatsApp message with all available data
    const message = `NEW TRAVEL ENQUIRY 

  Client Information:
• Name: ${formData.name || 'Not provided'}
• City: ${formData.city || 'Not provided'}
• Email: ${formData.email || 'Not provided'}
• Phone: ${formData.phone || 'Not provided'}
• WhatsApp: ${formData.whatsapp || 'Not provided'}

Travel Details:
• Travel Date: ${formData.travelDate ? new Date(formData.travelDate).toLocaleDateString('en-IN') : 'Not provided'}
• Duration: ${formData.noOfDays || 'Not provided'} days
• Persons: ${formData.noOfPersons || 'Not provided'}

 *Please contact this client at your earliest convenience!*`;

    // WhatsApp URL
    const whatsappNumber = '919489416969'; // +91 94894 16969
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

    // Open WhatsApp
    window.open(whatsappURL, '_blank');

    // Reset form and show success
    setFormData({
      name: '',
      city: '',
      email: '',
      phone: '',
      whatsapp: '',
      travelDate: '',
      noOfDays: '',
      noOfPersons: '',
      captcha: ''
    });
    setCaptchaQuestion(generateCaptcha());
    setShowSuccess(true);
    setIsSubmitting(false);
    setErrors({});

    setTimeout(() => setShowSuccess(false), 5000);
  };

  // Refresh captcha
  const refreshCaptcha = () => {
    setCaptchaQuestion(generateCaptcha());
    setFormData(prev => ({ ...prev, captcha: '' }));
    if (errors.captcha) {
      setErrors(prev => ({ ...prev, captcha: '' }));
    }
  };

  return (
    <div className="contact-page">

      {/* Form Section with Linear Gradient Background */}
      <section
        className="py-5"
        style={{
          backgroundImage: `
        linear-gradient(rgba(133, 133, 133, 0.6 )), url(${assets.world}) `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '100vh'
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,

            zIndex: 1
          }}
        />
        <Container style={{ position: 'relative', zIndex: 2 }}>
          <Row className="justify-content-center">
            <Col lg={8} xl={6}>
              <div className="text-center mb-5" data-aos="fade-up">
                <h3 className="fw-bold" style={{ color: '#ffffffff' }}>CLIENT INFORMATION</h3>
              </div>

              {/* Success Alert Only */}
              {showSuccess && (
                <Alert color="success" className="text-center mb-4">
                  <strong>Success!</strong> Your enquiry has been sent to WhatsApp.
                  Our team will contact you shortly!
                </Alert>
              )}

              <Form onSubmit={handleSubmit} className="contact-form">
                {/* ... (all your existing form fields remain exactly the same) */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="name" className="form-label fw-semibold">
                        Name <span className="text-danger">*</span>
                      </Label>
                      {/* <Input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className={errors.name ? 'is-invalid' : ''}
                        placeholder="Enter your full name"
                        required
                      /> */}
                      <Input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className={errors.name ? 'is-invalid' : ''}
                        placeholder="Enter your full name"
                        required
                        pattern="[A-Za-z\s\-']*"   // Allows letters, space, hyphen, apostrophe
                        onKeyPress={(e) => {
                          if (!/[A-Za-z\s\-']/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="city" className="form-label fw-semibold">
                        City
                      </Label>
                      <Input
                        type="text"
                        id="city"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        placeholder="Enter your city"
                        pattern="[A-Za-z\s\-']*"   // Allows letters, space, hyphen, apostrophe
                        onKeyPress={(e) => {
                          if (!/[A-Za-z\s\-']/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="email" className="form-label fw-semibold">
                        Email <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className={errors.email ? 'is-invalid' : ''}
                        placeholder="Enter your email address"
                        required
                        // This prevents invalid characters from being typed
                        onKeyPress={(e) => {
                          const allowedChars = /^[A-Za-z0-9.@_-]+$/;
                          if (!allowedChars.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        // Optional: also block space completely
                        onKeyDown={(e) => {
                          if (e.key === ' ') {
                            e.preventDefault();
                          }
                        }}
                      />
                      {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="phone" className="form-label fw-semibold">
                        Phone Number <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className={errors.phone ? 'is-invalid' : ''}
                        placeholder="Enter your phone number"
                        onKeyPress={(e) => {
                          if (!/[0-9+\-\s\(\)]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        required
                      />
                      {errors.phone && <div className="invalid-feedback d-block">{errors.phone}</div>}
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="whatsapp" className="form-label fw-semibold">
                        WhatsApp Number <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="tel"
                        id="whatsapp"
                        name="whatsapp"
                        value={formData.whatsapp}
                        onChange={handleChange}
                        className={errors.whatsapp ? 'is-invalid' : ''}
                        placeholder="Enter your WhatsApp number"
                        required
                        onKeyPress={(e) => {
                          if (!/[0-9+\-\s\(\)]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      {errors.whatsapp && <div className="invalid-feedback d-block">{errors.whatsapp}</div>}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="travelDate" className="form-label fw-semibold">
                        Travel Date
                      </Label>
                      <Input
                        type="date"
                        id="travelDate"
                        name="travelDate"
                        value={formData.travelDate}
                        onChange={handleChange}
                        min={new Date().toISOString().split('T')[0]}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="noOfDays" className="form-label fw-semibold">
                        No. of Days
                      </Label>
                      <Input
                        type="number"
                        id="noOfDays"
                        name="noOfDays"
                        value={formData.noOfDays}
                        onChange={handleChange}
                        placeholder="e.g. 5"
                        min="1"
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="noOfPersons" className="form-label fw-semibold">
                        No. of Persons
                      </Label>
                      <Input
                        type="number"
                        id="noOfPersons"
                        name="noOfPersons"
                        value={formData.noOfPersons}
                        onChange={handleChange}
                        placeholder="e.g. 4"
                        min="1"
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Updated Captcha Section - Better Layout */}
                <Row className="align-items-end">
                  <Col md={3}>
                    <FormGroup>
                      <Label for="captcha" className="form-label fw-semibold">
                        Captcha <span className="text-danger">*</span>
                      </Label>
                      <div className="position-relative">
                        <Input
                          type="text"
                          id="captcha"
                          name="captcha"
                          value={formData.captcha}
                          onChange={handleChange}
                          className={errors.captcha ? 'is-invalid' : ''}
                          placeholder="Enter answer"
                          maxLength="2"
                          style={{ maxWidth: '120px' }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          required
                        />
                        {errors.captcha && (
                          <div className="invalid-feedback d-block mt-1">{errors.captcha}</div>
                        )}
                      </div>
                      <small className="text-muted fw-semibold mt-1 d-block">
                        Solve: <span className="fw-bold" style={{ color: '#040695' }}>{captchaQuestion}</span>
                      </small>
                    </FormGroup>
                  </Col>
                  <Col md={2}>
                    <FormGroup className="mb-0">
                      <Button
                        type="button"
                        size="sm"
                        onClick={refreshCaptcha}
                        className="w-100 h-100"
                        style={{
                          color: 'white',
                          background: '#040695',
                          border: 'none',
                          borderRadius: '0.375rem',
                          height: '38px'
                        }}
                        title="Refresh Captcha"
                      >
                        <FiRefreshCw size={16} />
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Submit Button */}
                <FormGroup className="text-center mt-4">
                  <Button
                    type="submit"
                    size="lg"
                    className="px-5 py-3 fw-bold"
                    disabled={isSubmitting}
                    style={{ minWidth: '200px', color: 'white', backgroundColor: '#040695' }}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      <>

                        Submit
                      </>
                    )}
                  </Button>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Contact;